// extracted by mini-css-extract-plugin
export var actionText = "_s2-4";
export var container = "_s2-0";
export var leftSection = "_s2-1";
export var rightSection = "_s2-2";
export var settingsButton = "_s2-6";
export var settingsIcon = "_s2-7";
export var shortcut = "_s2-5";
export var shortcutGroup = "_s2-3";